import Button from '../../../../components/Button/Button';
import Constants from 'expo-constants';
import Svg, { Path } from 'react-native-svg';
import { Animated, StyleSheet,TouchableOpacity, View, useWindowDimensions } from 'react-native';
import { BasicModalBelow } from '../../../../components/Modal/BasicModalBelow';
import { COLORS, LEFT_BREATHING_COLORS, NEUTRAL_TEXT10, NEUTRAL_TEXT500, RIGHT_BREATHING_COLORS } from '../../../../config/designSystem/Colors';
import { CREATE_USER_EVENT } from '../../../../state/mutations/UserEvent';
import { Feather } from '@expo/vector-icons';
import { FlatList } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { MobileH1, ParagraphXLRegular, Subtitle2 } from '../../../../config/designSystem/typography';
import { ReactNode, useEffect, useRef, useState } from 'react';
import { SPACING } from '../../../../config/designSystem/Spacing';
import { StatusBar } from 'expo-status-bar';
import { client } from '../../../../config/apollo/client';
import { concatPath } from '../../../../utils/links/concatPath';
import { exerciceKey, libraryKey, privateKey } from '../../../../constants/routeKeys';
import { isAndroid, isWeb } from '../../../../config/designSystem/Layout';
import { logAmplitude } from '../../../../utils/analytics/analytics';
import { observer } from 'mobx-react';
import { router } from 'expo-router';
import { useStores } from '../../../../hooks/useStores';





export const Breathe = observer(() => {
  const rootStore = useStores();
  const {width, height} = useWindowDimensions(); // The problem with useAvailableDimensions is that the width is varying when the lateral bar disappears. Then firefox has a layout issue due to this variation. The main renderItem is not centered anymore. So we should keep useWindowDimensions rather than useAvailableDimensions


  const technique = rootStore.technique.getTechnique;

  const techniques = rootStore.technique.getTechniques;
  const techniqueIndex = rootStore?.technique.getTechniqueIndex;
  const [techniqueIndexModule5, setTechniqueIndexModule5] = useState(techniqueIndex);

  const durationArray = [-1, 1, 2, 5, 10, 20, 30, 0, -1];


  const durationIndex = rootStore?.technique.getDurationIndex(durationArray);


  const labels = rootStore?.language?.translate?.MOBILE?.SNACKING?.BREATHE;
  const BASIC_HEIGHT= Math.min(0.25 * height, 0.5* width);

  const [isModalVisible, setIsModalVisible] = useState(false);

  const HEIGHT = !isAndroid?height:(height+Constants.statusBarHeight);



  const goToExercise = () => {
    logAmplitude('Activity Started', {
      activityType: 'breathing',
      from: 'library',
      activityId: technique?.humanReadableId,
    });
    router.navigate(concatPath([exerciceKey ], 0) as string);

  };
  const goToHome = () => {

    router.navigate(concatPath([privateKey, libraryKey ], -1) as string);
  };




  const WIDTH_DURATION_ARROW = 50;
  const MARGIN_DURATION_ARROW = 30;


  const positionTop= height*0.06;
  const marginTop= positionTop + 50;

  const scrollRef = useRef<FlatList | null>(null);
  const scrollX = useRef(new Animated.Value(0));
  const scrollXDuration = useRef(new Animated.Value(0));
  const WIDTH_ADAPTED_FOR_DURATION = isWeb? width-4*MARGIN_DURATION_ARROW- 2*WIDTH_DURATION_ARROW: width;
  const WIDTH_DURATION = 0.25*WIDTH_ADAPTED_FOR_DURATION;
  const MARGIN_DURATION = 0.03*WIDTH_ADAPTED_FOR_DURATION;
  const SNAP_DURATION =  WIDTH_DURATION+2*MARGIN_DURATION;

  const SIZE_INFORMATION_CIRCLE = 10;
  const SIZE_MARGIN_CIRCLE = 10;
  const SIZE_FLATLIST_CIRCLE_ELEMENT = SIZE_INFORMATION_CIRCLE+2*SIZE_MARGIN_CIRCLE;

  const smallScrollRef = useRef<FlatList | null>(null);

  const durationScrollRef = useRef<FlatList | null>(null);

  const viewabilityConfig = {
    itemVisiblePercentThreshold: 90,
    waitForInteraction: false,
    minimumViewTime:isAndroid?100:0
  };



  const onViewableItemsChanged = ({ viewableItems }: any) => {
    if (!!viewableItems && viewableItems.length >0) {
      const nextIndex=viewableItems[0].index;
      rootStore?.technique.setTechniqueIndex(nextIndex);
    }
  };

  const viewabilityConfigCallbackPairs = useRef([{ viewabilityConfig, onViewableItemsChanged }]);


  useEffect(() => {
    goToDurationIndex(durationIndex-1);

  }, [durationIndex]);

  const goToDurationIndex = (index: number) => {

    durationScrollRef.current?.scrollToIndex({index,
      animated: true});

  };

  useEffect(() => {
    scrollingIndex(techniqueIndex, true);
    setTechniqueIndexModule5(techniqueIndex%LEFT_BREATHING_COLORS.length);
  }, [techniqueIndex]);





  const renderItem = ({item,index}) => {

    return (
      <Animated.View style={{width}}>
        {sequenceAndTitle(index)}
        {renderCenter()}
      </Animated.View>
    );
  };

  const renderDurationItem = ({item,index}) => {
    const secondPartlabel = labels?.MIN? labels.MIN:'min';
    const emptyMin = item === -1;
    const forever = item === 0;
    const selected = durationIndex === index;
    const opacity = selected? 1: 0.5;
    const color = selected ? COLORS.brand[500] : NEUTRAL_TEXT500;

    return(
      <View style={{ width: WIDTH_DURATION,marginHorizontal: MARGIN_DURATION, justifyContent:'center', alignItems:'center',opacity}}>
        {!emptyMin && !forever && (
          <ParagraphXLRegular color={color} align={true}>
            {item + ' ' + secondPartlabel}
          </ParagraphXLRegular>)}
        {forever && (<ParagraphXLRegular color={color} align={true}>
          {labels?.NO_LIMIT?labels.NO_LIMIT:'Forever'}
        </ParagraphXLRegular>)}
      </View>
    );
  };

  const renderSmallCircleItem = ({item,index}) => {
    const color = index === Math.round(techniqueIndex)? COLORS.brand[500] : NEUTRAL_TEXT10+'BB';
    return (
      <TouchableOpacity onPress={()=> {
        rootStore?.technique.setTechniqueIndex(index);
        scrollingIndex(index, false);

      }} >
        <Animated.View style={{marginHorizontal:SIZE_MARGIN_CIRCLE, alignSelf:'center', justifyContent:'center'}}>
          {renderCircle(SIZE_INFORMATION_CIRCLE, color, undefined)}
        </Animated.View>
      </TouchableOpacity>
    );
  };

  const renderCenter = () => {
    return(
      <View style={{
        alignItems:'center',
        justifyContent:'center',
        marginTop: height*0.08,
        columnGap: 25,
        flexDirection:'row'}}>
        {renderArrow(true)}
        {renderCircles()}
        {renderArrow(false)}
      </View>
    );
  };

  const scrollingIndex = (nextIndex: number, animated = true) => {
    scrollRef?.current?.scrollToIndex({
      index:nextIndex,
      animated
    });
    smallScrollRef?.current?.scrollToIndex({
      index:nextIndex,
      animated
    });
  };


  const renderArrow = (left: boolean) => {
    const condition = left? techniqueIndex !== 0 : Math.round(techniqueIndex+1) !== techniques.length;
    const nextIndex = left? Math.round(techniqueIndex-1) : Math.round(techniqueIndex+1);
    const SIZE= 32;
    return(
      <View style={{width:SIZE, height: SIZE}}>
        {condition && (
          <TouchableOpacity onPress={() => {
            rootStore?.technique.setTechniqueIndex(nextIndex);
          }}>
            <Feather name={left?'chevron-left':'chevron-right'} color='black'  size={SIZE}/>
          </TouchableOpacity>
        )}
      </View>
    );
  };

  const renderDurationArrow = (left: boolean) => {
    const condition = left? durationIndex >1 : durationIndex +2 < durationArray.length;
    const nextIndex = left? durationIndex-1 : durationIndex+1;
    return(
      <View style={{width:WIDTH_DURATION_ARROW/2, height: WIDTH_DURATION_ARROW/2, marginHorizontal: MARGIN_DURATION_ARROW,alignItems: 'center', justifyContent:'center'}}>
        {condition && (
          <TouchableOpacity onPress={() => {
            rootStore?.technique.setTimerDuration(durationArray[nextIndex]);
          }}>
            <Feather name={left?'chevron-left':'chevron-right'} color='black'  size={WIDTH_DURATION_ARROW/2}/>
          </TouchableOpacity>
        )}
      </View>
    );
  };


  const renderCircles = () => {
    return(
      <>
        {renderCircle(BASIC_HEIGHT,  'rgba(255, 255, 255, 0.09)', <>
          {
            renderCircle(BASIC_HEIGHT*0.76, 'rgba(255, 255, 255, 0.13)',<>

              {
                renderCircle(BASIC_HEIGHT*0.53, 'rgba(255, 255, 255, 0.2)', <>
                  {
                    renderCircle(BASIC_HEIGHT*0.33, 'rgba(255, 255, 255, 0.4)', null)
                  }
                </>)
              }</>)
          }
        </>)}

      </>);
  };

  const renderCircle = (width: number, color: string, child?: ReactNode) => {
    return(
      <View style={{
        width,
        height: width,
        alignItems:'center',
        justifyContent:'center',
        borderRadius: width/2,
        backgroundColor:color}} >
        {!!child && child}
      </View>

    );
  };


  const sequenceAndTitle = index => {
    const technique = techniques[index];
    return(	<TouchableOpacity onPress={()=>{setIsModalVisible(true);}} style={{
      flexShrink: 0,
      alignItems: 'center',
      justifyContent: 'center',
      rowGap: 8,
      marginTop:marginTop
    }}>
      <Subtitle2 color={COLORS.brand[500]} align={true}>
        {(labels?.PATTERN ? labels?.PATTERN + ': ' : '') + technique.durations.join('-')}
      </Subtitle2>
      <View style={{flexDirection:'row', alignItems:'center', justifyContent:'center', rowGap:8}}>
        <MobileH1 color={NEUTRAL_TEXT500} align={true}>
          {technique.name}
        </MobileH1>
        <View>
          <Svg style={{
            position: 'absolute',
            flexShrink: 0,
            top: -10,
            left: isWeb?5:0,
            overflow: 'visible'
          } } width="15" height="15" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <Path d="M10.01 0C4.49066 0 0 4.49066 0 10.01C0 15.5293 4.49066 20.02 10.01 20.02C15.5293 20.02 20.02 15.5293 20.02 10.01C20.02 4.49066 15.5293 0 10.01 0ZM10.01 1.54C14.6962 1.54 18.48 5.32383 18.48 10.01C18.48 14.6962 14.6962 18.48 10.01 18.48C5.32383 18.48 1.54 14.6962 1.54 10.01C1.54 5.32383 5.32383 1.54 10.01 1.54ZM9.24 5.39V6.93H10.78V5.39H9.24ZM9.24 8.47V14.63H10.78V8.47H9.24Z" fill="#2D3352"/>
          </Svg>
        </View>
      </View>

    </TouchableOpacity>);

  };


  return(
    <>

      <BasicModalBelow isVisible={isModalVisible}
        onDismiss={() => {setIsModalVisible(false);}}
        labelTitle={technique?.name}
        labelMain={technique?.description}
        labelButton={labels?.BUTTON_END_DESCRIPTION?labels.BUTTON_END_DESCRIPTION:'OK'}/>

      <View style={{flex:1}}>
        <LinearGradient start={{x:0,y:0}} end={{x:1,y:0}} colors={[LEFT_BREATHING_COLORS[techniqueIndexModule5],RIGHT_BREATHING_COLORS[techniqueIndexModule5]]}
          style={[
            styles.gradient,
            {
              width,
              height:HEIGHT}]} />
        <StatusBar style="light" />

        <View style={{flex: 1, justifyContent: 'space-between'}}>
          <View>
            <Animated.View style={[{marginBottom:30}, {zIndex:1}]}>

              <Animated.FlatList
                ref={scrollRef}
                data={techniques}
                keyExtractor={item => item._id}
                viewabilityConfigCallbackPairs={viewabilityConfigCallbackPairs.current}
                snapToInterval={width}
                snapToAlignment="start"
                horizontal={true}
                decelerationRate="fast"
                renderItem={renderItem}
                showsHorizontalScrollIndicator={false}
                onScroll={() => {
                  Animated.event([{ nativeEvent: { contentOffset: { x: scrollX.current } } }], {
                    useNativeDriver: true,
                  });

                }}
                scrollEventThrottle={16}
                onScrollToIndexFailed={()=>{

                  const wait = new Promise(resolve => setTimeout(resolve, 1000));
                  wait.then(() => {
                    scrollingIndex(techniqueIndex, false);
                  });
                }}
                contentContainerStyle={[isWeb && {width}]}
                initialScrollIndex={techniqueIndex}
                getItemLayout={(data, index) => ({
                  length: width,
                  offset: width * index,
                  index,
                })}
              />
            </Animated.View>

            <Animated.View style={{alignItems:'center', marginTop:30, justifyContent:'center'}}>
              <Animated.FlatList
                ref={smallScrollRef}
                data={techniques}
                keyExtractor={item => item._id}
                horizontal={true}
                decelerationRate="fast"
                renderItem={renderSmallCircleItem}
                scrollEnabled={false}
                showsHorizontalScrollIndicator={false}
                onScrollToIndexFailed={()=>{
                  const wait = new Promise(resolve => setTimeout(resolve, 1000));
                  wait.then(() => {
                    scrollingIndex(techniqueIndex,false);
                  });
                }}
                contentContainerStyle={[isWeb && {width}, {
                  paddingBottom: 30, alignItems:'center', justifyContent:'center'}]}
                getItemLayout={(data, index) => ({
                  length: SIZE_FLATLIST_CIRCLE_ELEMENT,
                  offset: SIZE_FLATLIST_CIRCLE_ELEMENT * techniqueIndex,
                  index,
                })}

              />
            </Animated.View>
            <View style={{flexDirection:'row', justifyContent:'space-between', alignItems:'center'}}>

              {isWeb && (renderDurationArrow(true))}
              <Animated.View style={{alignItems:'center', justifyContent:'center'}}>
                <Animated.FlatList
                  ref={durationScrollRef}
                  data={durationArray}
                  keyExtractor={(_item,index) => String(index)}
                  scrollEnabled={!isWeb}
                  horizontal={true}
                  decelerationRate="fast"
                  renderItem={renderDurationItem}
                  showsHorizontalScrollIndicator={false}
                  onScroll={e => {
                    Animated.event([{ nativeEvent: { contentOffset: { x: scrollXDuration.current } } }], {
                      useNativeDriver: true,
                    });
                  }}
                  onScrollToIndexFailed={info=>{
                    const wait = new Promise(resolve => setTimeout(resolve, 1000));
                    wait.then(() => {
                      goToDurationIndex(durationIndex-1);
                    });
                  }}
                  snapToInterval={SNAP_DURATION}
                  snapToAlignment="center"
                  style={{marginHorizontal:20}}
                  onMomentumScrollEnd={e=>{
                    const index = Math.min(durationArray.length -2, Math.max(0,1+Math.round(e.nativeEvent.contentOffset.x/SNAP_DURATION)));
                    rootStore?.technique.setTimerDuration(durationArray[index]);
                  }}
                  contentContainerStyle={[isWeb && {width:3*SNAP_DURATION}]}

                />
              </Animated.View>
              {isWeb && (renderDurationArrow(false))}
            </View>
          </View>

          <View style={{alignItems:'center', justifyContent:'center', alignSelf:'center', width:'90%', marginBottom: SPACING['sp-40']}}>
            <Button
              onPress={() => {
                client.mutate({
                  mutation: CREATE_USER_EVENT,
                  fetchPolicy:'no-cache',
                  variables: {
                    input: {
                      type:'BreathingStarted',
                      entityId:technique._id,
                      params: String(durationArray[durationIndex])
                    }
                  }
                });
                goToExercise();
              }}
              label={labels?.START?labels.START:'Start'}
              marginBottom={0}
            />
          </View>
        </View>
      </View>
    </>);

});


const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  gradient: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  },
});

export default Breathe;